import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import ReactCountryFlag from 'react-country-flag';

export const LanguageSelector = ({languageList}) => {
  const { i18n, t } = useTranslation();
  const [lang, setLang] = useState(i18n.language);
  const [langLabel, setLangLabel] = useState(t(`language-selector.aria-${lang}-flag`));

  const changeValueLang = lang => {
    setLang(lang);
    i18n.changeLanguage(lang);
    document.documentElement.lang = lang;
    setLangLabel(t(`language-selector.aria-${lang}-flag`));
  };

  const changeLanguage = evt => {
    let language = evt.target.value;
    changeValueLang(language);

  };  

  const styles = {
    container : {
      '& .MuiTextField-root': { width: '4.5em' },
      '& .MuiSvgIcon-root': {
        fill: '#FFFFFF'
      }
    },
    fieldStyle: {
      backgroundColor: 'inherit',
      borderRadius: '0.4em',
    },
    selectStyle: {
      fill: '#FFFFFF',
      fontSize: '1em'
    },
    styleInput: {
      padding: '10px !important'
    }
  };

  return (
    <Box id='language_selector' sx={styles.container}>
      <TextField
        value={lang}
        size='small'
        onChange={changeLanguage}
        sx= {styles.fieldStyle}
        inputProps={{ 
          sx: styles.styleInput,  
          'aria-label': t('language-selector.label', {lang: langLabel})
        }}
        select
        SelectProps={{
          sx: styles.selectStyle
        }}
      >
        {
          Object.entries(languageList).map(lang => {
            return (
              <MenuItem key={lang[1]} value={lang[1]}>
                <ReactCountryFlag 
                  countryCode={lang[0]}
                  svg
                  style={{
                    borderRadius: 8,
                    fontSize: '1.5em',
                  }}
                  alt={t(`language-selector.aria-${lang[1]}-flag`)} />
              </MenuItem>
            );
          })
        }
      </TextField>
    </Box>
  );
};
